// Animate When Visible
// Custom function based on https://github.com/wes337/io-animate
// Add class of 'io-animate' to animated modules
// Add data attributes of
// Uses animate.css https://animate.style/

function ioAnimate(
  selector = '.animate',
  cssPrefix = 'animate__',
	animType = 'backInUp',
	animSpeed = 'fast',
	animDelay = '0s'
)
{
	// Test that browser supports IntersectionObserver
	if (!('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
		// If not then stop all animations
    document.querySelectorAll(selector).forEach(el=>el.classList.remove(selector));
		return;
	}
  const intersectionObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
				if (entry.target.hasAttribute('data-anim-type'))
				{
					animType = entry.target.getAttribute('data-anim-type');
				}
				if (entry.target.hasAttribute('data-anim-speed'))
				{
					animSpeed = entry.target.getAttribute('data-anim-speed');
				}
				if (entry.target.hasAttribute('data-anim-delay'))
				{
					animDelay = entry.target.getAttribute('data-anim-delay');
				}
				//console.log('seen');
				// Add animation classes
        entry.target.classList.add(cssPrefix + 'animated', cssPrefix + animType, cssPrefix + animSpeed, cssPrefix + 'delay-' + animDelay);
				// Un-observe
				observer.unobserve(entry.target)
      }
    })
  })

  const elements = [...document.querySelectorAll(selector)]

  elements.forEach((element) => intersectionObserver.observe(element))
}

new ioAnimate();